import { PROGRESS_STATUS, StatusTypes } from '../../consts/enums';

const style = {
  colors: {
    [StatusTypes.declined]: {
      color: 'text.primary',
      backgroundColor: 'rgba(229, 231, 235, 1)',
    },
    [StatusTypes.request]: {
      color: 'secondary.main',
      backgroundColor: 'rgba(236, 9, 130, 0.12)',
    },
    [StatusTypes.review]: {
      color: 'primary.main',
      backgroundColor: 'rgba(48, 37, 133, 0.12)',
    },
    [StatusTypes.active]: {
      color: 'secondary.contrast',
      backgroundColor: 'primary.main',
    },
    [StatusTypes.published]: {
      color: 'secondary.states.hoverBackgroundContained',
      backgroundColor: 'secondary.states.hoverBackground',
    },
    [StatusTypes.inactive]: {
      color: 'action.active',
      backgroundColor: 'action.focus',
    },
    [StatusTypes.onboarding]: {
      color: 'primary.main',
      backgroundColor: 'rgba(48, 37, 133, 0.12)',
    },
    [PROGRESS_STATUS.COMPLETED]: {
      color: '#FFF',
      backgroundColor: 'success.main',
    },
    [PROGRESS_STATUS.IN_PROGRESS]: {
      color: '#FFF',
      backgroundColor: 'warning.main',
    },
    [PROGRESS_STATUS.ERROR]: {
      color: '#FFF',
      backgroundColor: 'error.main',
    },
  },
} as const;

export default style;
